import { atom } from 'recoil';

export const transactionCode = atom({
  key: 'transactionCode',
  default: undefined,
});
